import "../css/main.scss";

// Import utilities
import { init, lazyLoad, render, setDummyWidgetsData, lazyLoadVideo, scrollTo } from "@utilities";

// Import Vanilla JS components
import {
  Accordion,
  DownloadableQrCode,
  Tabs,
  Comparator,
  HorizontalScrollPanel,
  Masonry,
  Search,
  FormScrollTo,
  Cookie,
  Cta,
  Hamburger,
  branchDetailPageTabs,
  pauseYoutubeVideo,
  megaMenu,
  Collapse,
  Tooltip,
  appStore,
  appStoreRedirect,
  lightGallery,
  Analytics,
  AnalyticsView,
  AnalyticsPersonalizable,
  AnalyticsContent,
  Sticky,
  MarketingAlertStripe,
  MarketingAlertStripeMob,
  interactiveComponent,
  interactiveComponentMobile,
  ButtonKentico,
} from "@modules";

// Import React components
import {
  TransparentAccountList,
  TransparentAccountDetail,
  GalleryLightbox,
  ArticleList,
  Calculator,
  SearchList,
  TabsBranchesAtms,
  BranchesSearch,
  BranchesResultsDetail,
  DetailMap,
  AtmsSearch,
  AtmsResultsDetail,
  ExchangeRatesList,
  ExchangeRatesListSk,
  ExchangeRatesDetail,
  RateVariation,
  TooltipKentico,
  DonutChart,
  LineChart,
} from "@components";

// Set dummy widgets data for testing if needed
setDummyWidgetsData();

const urlParams = new URLSearchParams(window.location.search);

// Init Vanilla JS components
// single
init.single(DownloadableQrCode, document.querySelector(".js-downloadable-qr-container"));
init.single(Search, document.querySelector(".js-search-desktop"));
init.single(FormScrollTo, document.querySelector(".js-form-scroll-to"));
init.single(pauseYoutubeVideo, document.querySelector(".js-tabs"));
init.single(Cookie, document.querySelector(".js-cookie"));
init.single(branchDetailPageTabs, document.querySelector(".js-tabs-detail-branches"));
init.single(megaMenu, document.querySelector(".js-megaMenu"));
init.single(appStore, document.querySelector(".js-appStore"));
init.single(appStoreRedirect, document.querySelector(".js-appStoreRedirect"));
init.single(MarketingAlertStripe, document.querySelector(".js-marketingAlertStripe"));
if (urlParams.has("scrollTo")) {
  init.single(scrollTo, document.querySelector("body"));
}

// multiple
init.multiple(Accordion, document.querySelectorAll(".js-accordion-item"));
init.multiple(Tooltip, document.querySelectorAll(".js-tooltip-static"));
init.multiple(Tabs, document.querySelectorAll(".js-tabs"));
init.multiple(Comparator, document.querySelectorAll(".js-comparator"));
init.multiple(Hamburger, document.querySelectorAll(".js-hamburger"));
init.multiple(HorizontalScrollPanel, document.querySelectorAll(".js-horizontal-panel"));
init.multiple(Masonry, document.querySelectorAll(".js-tile"));
init.multiple(lazyLoad, document.querySelectorAll(".lazyload"));
init.multiple(lazyLoadVideo, document.querySelectorAll(".lazyloadvideo"));
init.multiple(Collapse, document.querySelectorAll(".js-collapse"));
init.multiple(Cta, document.querySelectorAll(".js-cta"));
init.multiple(lightGallery, document.querySelectorAll(".js-lightgallery"));
init.multiple(Analytics, document.querySelectorAll("[data-analytics]"));
init.multiple(Sticky, document.querySelectorAll(".sticky"));
init.multiple(AnalyticsView, document.querySelectorAll("[data-analytics-view]"));
init.multiple(
  AnalyticsPersonalizable,
  document.querySelectorAll("[data-analytics-personalizable]")
);
init.multiple(AnalyticsContent, document.querySelectorAll("[data-analytics-content]"));
init.multiple(interactiveComponent, document.querySelectorAll(".js-interactiveComponent"));
init.multiple(
  interactiveComponentMobile,
  document.querySelectorAll(".js-interactiveComponentMobile")
);
init.multiple(MarketingAlertStripeMob, document.querySelectorAll(".js-marketingAlertStripe-mob"));
init.multiple(ButtonKentico, document.querySelectorAll(".js-button-kentico"));

// Render React components
// single
render.single(TransparentAccountList, document.querySelector(".js-transparent-list"));
render.single(TransparentAccountDetail, document.querySelector(".js-transparent-detail"));
render.single(ArticleList, document.querySelector(".js-article-list"));
render.single(Calculator, document.querySelector(".js-calculator"));
render.single(SearchList, document.querySelector(".js-search-list"));
render.single(TabsBranchesAtms, document.querySelector(".js-tabs-branches-atms")); // Branches & ATMs
render.single(DetailMap, document.querySelector(".js-detail-map"));
render.single(BranchesSearch, document.querySelector(".js-branches-search")); // Branches
render.single(BranchesResultsDetail, document.querySelector(".js-branches-results-detail"));
render.single(AtmsSearch, document.querySelector(".js-atms-search")); // ATMs
render.single(AtmsResultsDetail, document.querySelector(".js-atms-results-detail"));
render.single(ExchangeRatesList, document.querySelector(".js-exchange-rates-list")); // Exchange Rates - List
render.single(ExchangeRatesListSk, document.querySelector(".js-exchange-rates-list-sk")); // Exchange Rates - List SK
render.single(ExchangeRatesDetail, document.querySelector(".js-exchange-rates-detail")); // Exchange Rates - Detail
render.single(RateVariation, document.querySelector(".js-fx-profit-margin")); // ECB
render.single(LineChart, document.querySelector(".js-line-chart"));

// multiple
render.multiple(GalleryLightbox, document.querySelectorAll(".js-gallery-lightbox"), false);
render.multiple(TooltipKentico, document.querySelectorAll(".js-tooltip-kentico"));
render.multiple(DonutChart, document.querySelectorAll(".js-donut-chart"));

// call external sas after our js
if (window.setSas) {
  window.setSas();
}
